export const BodyDataAndKeyTypes = [
  {
    key: "",
    type: "",
  },
  {
    key: "title",
    type: "",
    prepend: "",
  },
];
